<template>
  <div
    class="plc-main"
    v-loading.fullscreen.lock="loading"
    element-loading-background="rgba(255, 255, 255, 0.8)"
  >
    <Content v-if="!loading"></Content>
  </div>
</template>

<script>
import Content from '../layout/plc/content.vue'
import Cookies from 'js-cookie'
import { getAccessToken } from '@/utils/userInfo'

export default {
  components: { Content },
  data () {
    return {
      loading: true
    }
  },
  computed: {
    haveToken () {
      let token = getAccessToken()
      let result = false
      if (token && token !== 'null' && token !== 'undefind' && token !== '') {
        result = true
      }
      return result
    }
  },
  created () {
    if (this.haveToken) {
      Promise.all([this.getUserInfo()]).finally(() => {
        this.loading = false
      })
    } else {
      this.loading = false
    }
  },
  methods: {
    // 获取当前管理员信息
    getUserInfo () {
      return this.$http
        .get('/front/consumer/usercenter/custUserCenterInfo', {
          params: {
            appCode: 'PLANTMATE_OFFICIAL',
            companyId: this.$store.state.user.defaultCompanyId + '' || ''
          }
        })
        .then(({ data: res }) => {
          if (res.code !== 0) {
            return false
          }
          // this.$store.state.cardInfo = res.data.cardInfo
          this.$store.dispatch('companyList', res.data.companyAccountInfo || [])
          this.$store.dispatch('setUserInfo', res.data.userInfo)
          Cookies.set('userId', res.data.userInfo.userId)
          Cookies.set('mobile', res.data.userInfo.mobile)
          // this.$store.state.user.username = res.data.userInfo.username
          // this.$store.state.user.name = res.data.userInfo.name
          // this.$store.state.user.mobile = res.data.userInfo.mobile
          // this.$store.state.user.email = res.data.userInfo.email
          // 获取生态服务用户数据
          this.getEcologyUserInfo(res.data.userInfo.userId)
          this.getCorpUser();
        })
        .catch(() => {})
    },
    getEcologyUserInfo (userId) {
      return this.$http
        .get(`/front/oms/supplier/User/getSsoUserInfoByUserId/${userId}`)
        .then(({ data: res }) => {
          if (res.code == 0) {
            // 手动修改用户类型
            // res.data.userType = 2
            this.$store.commit('setEcologyUserInfo', res.data)
          }
        })
    },
    getCorpUser() {
      return this.$http
        .get("/front/sys/crop-site/customer-crop-site")
        .then(({ data: res }) => {
          if (res.code === 0) {
            this.$store.commit("setCorpUserInfo", res.data || {});
          }
        });
    },
  }
}
</script>

<style lang="scss" scoped>
.plc-main {
  background: url('~@/assets/img/plc/bg1.png') no-repeat;
  background-size: 100% 100%;
  background-attachment: fixed;
  padding: 0 24px;
  height: 100vh;
}
</style>
